import type { AuthState } from "./auth-state";

/**
 * The header account button must reflect an authenticated Identity session even before an
 * organization or project is selected. `AuthState.identity` is non-null exactly for
 * "authenticated-no-organization", "authenticated-no-project", and "project-readonly" (every
 * other status clears cloud context via `clearCloudContext`), so branching on `identity !== null`
 * covers those two intermediate authenticated statuses without special-casing them by name.
 */
export function authAccountButtonLabel(auth: AuthState): string {
  if (auth.status === "project-readonly") return auth.project?.name ?? "Cloud account";
  if (auth.status === "starting" || auth.status === "callback-verifying") return "Signing in…";
  if (auth.identity !== null) return auth.identity.displayName;
  return "Sign in";
}

export function authAccountButtonAriaLabel(auth: AuthState): string {
  if (auth.status === "project-readonly") {
    return `Cloud account · ${auth.project?.name ?? "read-only project"}`;
  }
  if (auth.identity !== null) return `Cloud account · ${auth.identity.displayName}`;
  return "Sign in to a cloud workspace";
}
